module.exports = __webpack_public_path__ + "mainassets/img/ic-promo-placeholder.a2962c68.svg";